module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "C333",
    attrs: {
      "id": "page_x"
    }
  }, [_c('strong', [_vm._v("CHRONOLOGY")])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "C396",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "T316_FirstRow"
  }, [_c('td', {
    staticClass: "C398",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("11 September 1885")]), _vm._v(" "), _c('td', {
    staticClass: "C399",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Born in Eastwood, Nottinghamshire")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1898–July 1901")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Pupil at Nottingham High School")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("1902–1908")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Pupil teacher; student at University College, Nottingham")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("7 December 1907")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("First publication: 'A Prelude', in "), _c('em', [_vm._v("Nottinghamshire Guardian")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October 1908")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Appointed as teacher at Davidson Road School, Croydon")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("November 1909")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Publishes five poems in "), _c('em', [_vm._v("English Review")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("3 December 1910")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Engagement to Louie Burrows; broken off on 4 February 1912")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("9 December 1910")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Death of his mother, Lydia Lawrence")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("19 January 1911")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The White Peacock")]), _vm._v(" published in New York (20 January in London)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("19 November 1911")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Ill with pneumonia; resigns his teaching post on 28 February 1912")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1912")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Meets Frieda Weekley; they elope to Germany on 3 May")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("23 May 1912")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Trespasser")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1912–March 1913")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Gargnano, Lago di Garda, Italy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("February 1913")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Love Poems and Others")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("29 May 1913")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Sons and Lovers")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June–August 1913")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In England")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("August 1913–June 1914")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Germany, Switzerland and Italy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("1 April 1914")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Widowing of Mrs. Holroyd")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1914–December 1915")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In London, Buckinghamshire and Sussex")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("13 July 1914")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Marries Frieda Weekley in London")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("26 November 1914")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Prussian Officer and Other Stories")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("30 September 1915")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Rainbow;")]), _vm._v(" suppressed by court order on 13 November")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June 1916")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Twilight in Italy")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1916")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Amores")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("15 October 1917")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("After twenty-one months' residence in Cornwall, ordered to leave by military authorities")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("October 1917–November 1919")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In London, Berkshire and Derbyshire")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("26 November 1917")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Look! We Have Come Through!")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October 1918")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("New Poems")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("20 November 1919")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Bay")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("November 1919–7 March 1920")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("To Italy, and then Capri")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("8 March 1920")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Fontana Vecchia, Taormina, Sicily")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("May 1920")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Touch and Go")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("9 November 1920")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Private publication of "), _c('em', [_vm._v("Women in Love")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("25 November 1920")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Lost Girl")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("4–5 January 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Travel from Taormina to Palermo")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("5–13 January 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Sardinia: visit Cagliari, Mandas, Sorgono, Nuoro, Terranova; return to Sicily via Rome and Naples")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("by 21 January 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Begins writing 'Diary of a Trip to Sardinia' "), _c('em', [_vm._v("(Sea and Sardinia)")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("c")]), _vm._v(". 27 January 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Visited by Jan Juta")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("February 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Movements in European History")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("12 February 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("The 'Diary' 'nearly done'")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("22 February 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'I have finished the \"Diary of a Trip to Sardinia\"'")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("by 22 February 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("MS sent to Ruth Wheelock for typing")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Revises typescripts")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("by 22 March 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Last portion of TSS received")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("28 March 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Sends revised TSS to Robert Mountsier and to Barbara Low")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("27 April–10 July 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Hotel Krone, Ebersteinberg, Baden-Baden")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("May 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Juta in Sardinia painting illustrations for the 'Diary'")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("10 May 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Psychoanalysis and the Unconscious")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("1 June 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Finishes "), _c('em', [_vm._v("Aaron's Rod;")]), _vm._v(" begins "), _c('em', [_vm._v("Fantasia of the Unconscious")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("c")]), _vm._v(". 10 June 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Women in Love")]), _vm._v(" published in England by Secker")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("23 June 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Receives five of Juta's eight pictures")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("by 4 July 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Has received remaining three pictures from Juta")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("5"), _c('em', [_vm._v("–c")]), _vm._v(". 27 July 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Mountsier visits Lawrences")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("10–19 July 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("To Zell-am-See via Austria")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("20 July–25 August 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Villa Alpensee, Zell-am-See")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("by 30 July 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Title "), _c('em', [_vm._v("Sea and Sardinia")]), _vm._v(" decided")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("25 August–19 September 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At 32 Via dei Bardi, Florence")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("20–7 September 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Siena, Rome, Capri")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("28 September 1921–20 February 1922")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Fontana Vecchia")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("20 October 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Seltzer sends galley proofs of "), _c('em', [_vm._v("Sea and Sardinia")]), _vm._v(" to Mabel Mountsier for correction")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October and November 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Extracts from "), _c('em', [_vm._v("Sea and Sardinia")]), _vm._v(" in the "), _c('em', [_vm._v("Dial")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("12 December 1921")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Sea and Sardinia")]), _vm._v(" published in the USA by Seltzer")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March–August 1922")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Ceylon and Australia")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("14 April 1022")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Aaron's Rod")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1922–March 1923")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In New Mexico")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("23 October 1922")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Fantasia of the Unconscious")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("24 October 1922")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("England, My England")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("by 22 March 1923")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Ladybird, The Fox, The Captain's Doll")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March–November 1923")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Mexico and USA")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("April 1923")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Sea and Sardinia")]), _vm._v(" published by Secker")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("27 August 1923")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Studies in Classic American Literature")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1923")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Kangaroo")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("9 October 1923")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Birds, Beasts and Flowers")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("December 1923–March 1924")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In England, France and Germany")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1924–September 1925")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In New Mexico and Mexico")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("28 August 1924")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Boy in the Bush")]), _vm._v(" (with M. L. Skinner)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("10 September 1924")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Death of his father, John Arthur Lawrence")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("14 May 1925")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("St. Mawr together with The Princess")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1925–June 1928")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In England and, mainly, in Italy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("7 December 1925")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Reflections on the Death of a Porcupine")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("21 January 1926")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("(Philadelphia) "), _c('em', [_vm._v("The Plumed Serpent")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("25 March 1926")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("David")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June 1927")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Mornings in Mexico")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("24 May 1928")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Woman Who Rode Away and Other Stories")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June 1928–March 1930")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Switzerland and, principally, in France")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1928")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Lady Chatterley's Lover")]), _vm._v(" privately published (Florence)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1928")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("Collected Poems")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1929")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Exhibition of paintings in London raided by police; "), _c('em', [_vm._v("Pansies")]), _vm._v(" (manuscript earlier seized in the mail)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_Row"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1929")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', [_vm._v("The Escaped Cock")]), _vm._v(" (Paris)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T316_LastRow"
  }, [_c('td', {
    staticClass: "C397",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("2 March 1930")]), _vm._v(" "), _c('td', {
    staticClass: "C3977",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Dies at Vence, Alpes Maritime, France")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8604ed7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chronology.vue
// module id = 81
// module chunks = 0